/* Page-level error boundary with a Retry CTA. */
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info);
    }
  }

  handleRetry = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: 32,
            margin: "32px auto",
            maxWidth: 520,
            background: "var(--paper-2)",
            border: "1px solid var(--line)",
            borderRadius: 12,
            textAlign: "center",
          }}
        >
          <h3 style={{ margin: "0 0 8px", color: "#0a0a0a" }}>Something went wrong</h3>
          <p style={{ margin: "0 0 16px", color: "var(--ink-3)", fontSize: 14 }}>
            {String(this.state.error?.message || this.state.error || "Unknown error")}
          </p>
          <button className="btn btn-primary btn-sm" type="button" onClick={this.handleRetry}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
export default ErrorBoundary;
